<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <!-- top -->
    <div class="flex items-center -mt-5 md:-mt-10">
      <h3 class="text-center text-xl font-semibold text-root-2 w-full">
        {{ isCreate ? 'Create' : 'Edit' }} Payment Link
      </h3>
    </div>
    <!-- form body -->
    <payment-link-form @successful="successful" :mode="mode" />
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import createPaymentLink from '@/mixins/paymentLink.js'
export default {
  mixins: [createPaymentLink],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: ''
    }
  },
  components: {
    PaymentLinkForm: () =>
      import('@/components/receivePayment/forms/PaymentLinkForm.vue')
  },
  data () {
    return {
      breakpoints,
      isLoading: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    successful (view) {
      this.$emit('successful', view)
      this.handleClose()
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isCreate () {
      return this.mode === 'create'
    },
    isEdit () {
      return this.mode === 'edit'
    }
  }
}
</script>

<style scoped></style>
